<app-admin-header
  [header]="header"
  [breadcrumbs]="breadcrumbs"
  [stats]="stats"
  [links]="links"
  *ngIf="isUserLoggedIn"
></app-admin-header>

<!-- Public Header for Unauthenticated Users -->
<div *ngIf="!isUserLoggedIn" class="banner-public">
  <app-nav></app-nav>
  <section class="banner">
    <div class="air"></div>
    <div class="pos-rel">
      <div class="p-4 mx-height w-100 mt-3">
        <div class="v4-flex w-100">
          <div class="m-1-5-rem">
            <div class="directory-v4">{{ header | translator }}</div>
          </div>
          <div class="ms-auto pe-4">
            <a href="/" class="btn btn-light btn-lg">
              <i class="pi pi-arrow-right me-2"></i>
              {{ "Home page" | translator }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div class="videos-container">
  <div class="category-toggle" *ngIf="categories.length > 1">
    <p-button
      *ngFor="let cat of categories"
      [label]="cat"
        [ngClass]="selectedCategory !== cat ? 'outlined' : 'filled'"
      (onClick)="selectCategory(cat)">
    </p-button>
  </div>

<div class="videos-grid py-4">
    <div *ngFor="let video of filteredVideos" class="video-card" (click)="openVideo(video)">
        <div class="thumbnail-wrapper">
            <img [src]="video.thumbnail" [alt]="video.title" class="thumbnail">
        </div>
        <h3 class="p-2">{{ video.title }}</h3>
    </div>
</div>

  <p-dialog
    [(visible)]="displayModal"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '70vw' }"
    (onHide)="closeModal()">
    <ng-template pTemplate="header">
      <div class="d-flex justify-content-between align-items-center w-100">
        <h2>{{ selectedVideo?.title }}</h2>
        <button 
          pButton 
          type="button" 
          icon="pi pi-share-alt" 
          class="p-button-rounded p-button-text p-button-plain"
          (click)="copyShareLink(selectedVideo!)"
          [pTooltip]="'Copy Link' | translator"
          tooltipPosition="left"
        ></button>
      </div>
    </ng-template>
    <video *ngIf="selectedVideo" controls autoplay class="video-player">
      <source [src]="selectedVideo.videoUrl" type="video/mp4">
      Your browser does not support the video tag.
    </video>
    <p>{{ selectedVideo?.description }}</p>
  </p-dialog>
</div>

<app-footer></app-footer>